<template>
  <div>  
    <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0" 
          v-if="numberOfChannelVerification.length > 0">
      <template #toggler>
        <div>
          <CHeaderNavLink>
            <div class="header-link-icons">  
             <!-- <router-link  :to="{path: '/home/channelVerification' }">  -->  
                <font-awesome-icon :icon="['fas', 'flag-pennant']" style="color:#fff;font-size:18px;"           
                ></font-awesome-icon>
                <CBadge color="danger">{{getCount}}</CBadge>
            <!--  </router-link>  -->
            </div>
          </CHeaderNavLink>
        </div>
      </template>
      <CDropdownHeader
        tag="div"
        class="text-center"
        style="color:whitesmoke;background-color:#373737;"
      >
        <strong>My Actions</strong>
      </CDropdownHeader>
        <div  v-for="(category, index) in numberOfChannelVerification" :key="index">
        <div class="cvTitle">{{ category.categoryName }}</div>
          <CDropdownItem class="actionsItem"  v-for="(item, index) in category.categoryItems" :key="index" >
            <div  @click="redirectToChannelVerification(item.drpdownParameters, category.categoryName)">
              <router-link
              :to="{
                name: 'Home Channel Verification',
              }">
                <span style="text-decoration:underline;cursor:pointer;">
                  {{ item.dropdownValue }}
                </span>
              </router-link>
            </div>
            </CDropdownItem>
          </div>
       <!-- <CDropdownItem class="actionsItem"  v-if="numberOfChannelVerification.OPSCount > 0">
            <div @click="redirectToChannelVerification('OPS')">
              TAM Phase 1 (OPS Approval: {{numberOfChannelVerification.OPSCount}}) </div>
        </CDropdownItem>
        <CDropdownItem class="actionsItem" v-if="numberOfChannelVerification.ENGCount > 0">
            <div @click="redirectToChannelVerification('ENG')">
                TAM Phase 1 (ENG Approval: {{numberOfChannelVerification.ENGCount}}) </div>
        </CDropdownItem>
        <CDropdownItem class="actionsItem" v-if="numberOfChannelVerification.RejectCount > 0">
            <div @click="redirectToChannelVerification('Reject')">
                TAM Phase 1 (Reject: {{numberOfChannelVerification.RejectCount}}) </div>
        </CDropdownItem> -->
      </CDropdown>
    <div v-else>
      <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
        <template #toggler>
          <div>
            <CHeaderNavLink>
              <div class="header-link-icons">  
                <font-awesome-icon :icon="['fas', 'flag-pennant']" style="color:#fff;font-size:18px;"           
                ></font-awesome-icon>
            </div>
          </CHeaderNavLink>
        </div>
      </template>
      <CDropdownHeader
        tag="div"
        class="text-center"
        style="color:whitesmoke;background-color:#373737;"
      >
        <strong>My Actions</strong>
      </CDropdownHeader>
      <CDropdownItem class="actionsItemNoAction">
            <div>No Actions</div>
        </CDropdownItem>
         <CDropdownItem class="actionsItem" v-if="numberOfChannelVerification.OPSCount2 > 0">
            <div
                @click="redirectToChannelVerification('OPS')">
              TAM Phase 2 (OPS Approval: {{numberOfChannelVerification.OPSCount2}}) </div>
        </CDropdownItem>
        <CDropdownItem class="actionsItem" v-if="numberOfChannelVerification.ENGCount2 > 0">
            <div
                @click="redirectToChannelVerification('ENG')">
                TAM Phase 2 (ENG Approval: {{numberOfChannelVerification.ENGCount2}}) </div>
        </CDropdownItem>
        <CDropdownItem class="actionsItem" v-if="numberOfChannelVerification.RejectCount2 > 0">
            <div
                @click="redirectToChannelVerification('Reject')">
                TAM Phase 2 (Reject: {{numberOfChannelVerification.RejectCount2}}) </div>
        </CDropdownItem>
    </CDropdown>
    </div>
  </div>
</template>
<script>
import { EventBus } from '../../components/Events';

  export default {
    name: "MyActionsDropdown",
    components: {
    },
    data() {
      return {
        dashboardKey: true,
        channelVerificationCount: 0
      }
    },
    props: {
      numberOfChannelVerification: Array
    },
    mounted: function (){
     
    },
    computed: {
      getCount() {
        console.log(this.numberOfChannelVerification);
        this.channelVerificationCount  = 0;
        this.channelVerificationCount = this.numberOfChannelVerification.length;

        for(var index = 0;index < this.numberOfChannelVerification.length;index++){
          let currentCategory = this.numberOfChannelVerification[index]; 
          this.channelVerificationCount = currentCategory.categoryItems.length;
        }
      /*  if(this.numberOfChannelVerification.OPSCount > 0){
          this.channelVerificationCount += 1;
        }
        if(this.numberOfChannelVerification.ENGCount > 0){
          this.channelVerificationCount += 1;
        }
        if(this.numberOfChannelVerification.RejectCount > 0){
          this.channelVerificationCount += 1;
        } */
        return this.channelVerificationCount 
      }
    },
    methods: {
      redirectToChannelVerification(dropDownParameters, categoryName){
          if(categoryName != null && categoryName == 'Channel Verifications'){
            setTimeout(() => {
              EventBus.$emit('set-project-filter', [dropDownParameters[0], dropDownParameters[1]]);
            }, 500);
            //this.$router.push({name: 'Channel Verification'}).catch(()=>{
            //EventBus.$emit('filter-type-change', filterType);
            //});
          }
      }
    }
    }
</script>
<style lang="scss" scoped>
  .header-link-icons {
    font-size: 18px;
    color: #fff;
    margin: 0px 0px 0px 10px;
    cursor: pointer;

    .badge {
      position: absolute;
      font-size: 8px;
      width: 12px;
      margin-left:10px !important;

      top: 34px;
      opacity: .8;
    }
  }
a{
  text-decoration:none !important;
}
.cvTitle{
  font-weight: bold;
  color:black;
  pointer-events: none;
  padding-left: 10px; 
  padding-top: 5px;
}

.actionsItem:active{
    background-color: #d4d8dc;
}
.actionsItemNoAction{
  font-style: italic;
  pointer-events: none;
  color: #636f83;
  padding-left: 55px;
}
</style>